import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { useTaxpayerCertificate } from '../../hooks/hacienda/useTaxpayerCertificate';
import { taxpayerCertificateColumns } from '../../features/hacienda/taxpayerCertificateColumns';

import TaxpayerCertificateUploadModal from '../../components/Hacienda/TaxpayerCertificateUploadModal';
import TaxpayerCertificateEditModal from '../../components/Hacienda/TaxpayerCertificateEditModal';

import { TaxpayerCertificate } from '../../types/hacienda/TaxpayerCertificateTypes';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const TaxpayerCertificateUploadPage = () => {
  const {
    certificates,
    isLoading,
    isSubmitting,
    certificateToEdit,
    fetchCertificates,
    uploadCertificate,
    updateCertificate,
    deleteCertificate,
    editModalOpen,
    uploadModalOpen,
    openUploadModal,
    closeUploadModal,
    closeEditModal,
    selectCertificateToEdit,
  } = useTaxpayerCertificate();

  const columns = useMemo(() => taxpayerCertificateColumns, []);

  useEffect(() => {
    fetchCertificates();
  }, []);

  const getActions = (row: TaxpayerCertificate) => [
    {
      key: 'edit',
      label: 'Actualizar',
      onClick: () => selectCertificateToEdit(row),
    },
    {
      key: 'cancel',
      label: 'Eliminar',
      onClick: async () => {
        await deleteCertificate(row.fileType);
      },
    },
  ];

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Carga de Archivos de Certificados" /> */}
      <BreadcrumbTwo />

      <UniversalRecordTable
        columns={columns}
        data={certificates}
        getActions={getActions}
        showPagination={false}
        enableRowClick={true}
        noDataMessage="No hay certificados cargados."
        isLoading={isLoading}
        topRightAction={{
          label: 'Subir Certificado',
          onClick: openUploadModal,
        }}
      />

      <TaxpayerCertificateUploadModal
        isOpen={uploadModalOpen}
        onClose={closeUploadModal}
        onSubmit={uploadCertificate}
        isSubmitting={isSubmitting}
      />

      <TaxpayerCertificateEditModal
        isOpen={editModalOpen}
        onClose={closeEditModal}
        onSubmit={updateCertificate}
        initialType={certificateToEdit?.fileType || null}
        isSubmitting={isSubmitting}
      />
    </DefaultLayout>
  );
};

export default TaxpayerCertificateUploadPage;
